import { DropdownMenu as MenuPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from './cn.ts';

/** shadcn's dropdown menu on the kit's tokens: a white card under its trigger, items 44 px tall. */
export const UiMenu = MenuPrimitive.Root;
export const UiMenuTrigger = MenuPrimitive.Trigger;

export function UiMenuContent({ className, sideOffset = 8, align = 'end', ...props }: ComponentProps<typeof MenuPrimitive.Content>) {
  return (
    <MenuPrimitive.Portal>
      <MenuPrimitive.Content
        data-slot="menu-content"
        sideOffset={sideOffset}
        align={align}
        className={cn('z-50 flex min-w-[14rem] flex-col rounded-control border border-line bg-surface p-s1 font-sans text-body text-ink shadow-float data-[state=open]:animate-pop-in motion-reduce:animate-none', className)}
        {...props}
      />
    </MenuPrimitive.Portal>
  );
}

export function UiMenuLabel({ className, ...props }: ComponentProps<typeof MenuPrimitive.Label>) {
  return <MenuPrimitive.Label data-slot="menu-label" className={cn('flex flex-col gap-s1 px-s3 py-s2', className)} {...props} />;
}

export function UiMenuItem({ className, ...props }: ComponentProps<typeof MenuPrimitive.Item>) {
  return (
    <MenuPrimitive.Item
      data-slot="menu-item"
      className={cn('flex min-h-control cursor-pointer items-center gap-s2 rounded-control px-s3 outline-none select-none data-[highlighted]:bg-sunk [&_svg]:size-s4 [&_svg]:text-ink-2', className)}
      {...props}
    />
  );
}

export function UiMenuSeparator() {
  return <MenuPrimitive.Separator className="my-s1 h-px bg-line" />;
}
